import { render, staticRenderFns } from "./prepend.vue?vue&type=template&id=bb5068b8&"
import script from "./prepend.vue?vue&type=script&lang=js&"
export * from "./prepend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports